import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormHome } from '../../forms';
import { addHome } from '../../../../data/Homes/actions';
import selectors from '../../selectors';

class Step3 extends PureComponent {
    static propTypes = {
        homeForm: PropTypes.object.isRequired,
        saveHome: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { homeForm, saveHome } = this.props;
        return <FormHome sendDataFunc={saveHome} stepHomeForm={homeForm} type="add" />;
    }
}

function mapStateToProps(state) {
    return {
        profile: selectors.getProfile(state)
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ addHome }, dispatch)
    )(Step3)
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/components/stepper/Step3.js